<template>
    <div class="detailBooking" style="min-height:85vh">
        <div style="position:relative">
            <div style="margin: 16px 0;display:flex">
                <a-breadcrumb style="margin-top:auto;margin-bottom:auto">
                    <a-breadcrumb-item style="font-size:30px;">Detail booking</a-breadcrumb-item>
                    <!-- <a-breadcrumb-item>Bill</a-breadcrumb-item> -->
                </a-breadcrumb>
            </div>
            
            <a-button style="margin-left:5px;position:absolute;top: 0;right: 0;" @click="generateReport">Export Pdf</a-button>
        </div>
        <div style="display:flex">
                
            <div style="border:1px #eeeeee solid;max-width:1280px;padding:30px;min-height:500px;position: relative;margin-left: auto;margin-right: auto;">
                
                <div style="display: block;font-family: Montserrat;text-align: left;">
                    <div style="display: flex;display: -webkit-box;width:100%">
                        <div style="margin-top: 5px;margin-right: 5px;">
                        <img width="50px" height="50px" src="data:image/png;base64,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" alt="" />
                        </div>
                        <div style="margin-left:0;margin-right:auto;width: 100%;">
                        <div style="color: #c8ad93;font-size: 30px;font-family: Montserrat;font-weight: 500;font-style: normal;">VUE MALDIVES</div>
                        <div style="color: #505050;font-size: 14px;font-family: Montserrat;font-weight: 500;font-style: normal;">
                            UNIQUE COLLECTION OF MALDIVES FINEST RESORTS
                        </div>
                        </div>
                    </div>
                    <div style="color: #1a1a1a;font-size: 18px;font-family: Montserrat;font-weight: 600;font-style: bold;margin-right:0;margin-left:auto;width: 50%;text-align: right;">
                        COMFIRMATIOM NO: {{confirmationNo != ''? confirmationNo : 'PENDING'}}
                    </div>
                    <!-- <div style="display: flex;">
                        <img width="50%" src="./images/homeAboutImage1.png" alt="">
                        <img width="50%" src="./images/homeAboutImage2.png" alt="">
                    </div> -->
                    
                    <div style="display: flex;">
                    
                        <img width="50%" :src="hotelimage1 != undefined ? hotelimage1 : ''" alt="">
                        <img width="50%" :src="hotelimage2 != undefined ? hotelimage2 : ''" alt="">
                        <!-- <img width="50%" :src="selectedHotel != undefined && selectedHotel.quoteinfomation != undefined ? selectedHotel.quoteinfomation.imageone : ''" alt="">
                        <img width="50%" :src="selectedHotel != undefined && selectedHotel.quoteinfomation != undefined ? selectedHotel.quoteinfomation.imagetwo : ''" alt=""> -->
                        <!-- https://maldive-storage.s3.us-east-2.amazonaws.com…02885-%40-ICON+IMAGES/1660366595803-%40-JMfcI.png -->
                    </div>
                    <div style="padding:50px">
                        <div style="display: flex;display: -webkit-box;">
                        <div style="width: 50%;">
                            <div class="itemTitle">
                            HOTEL NAME:
                            </div>
                            <div class="itemText">
                            {{hotelname}}
                            </div>
                        </div>
                        <div style="width: 50%;">
                            <div class="itemTitle">
                            ADDRESS:
                            </div>
                            <div class="itemText">
                            {{address}}
                            </div>
                        </div>
                        </div>
                        <div style="display: flex;margin-top:30px;display: -webkit-box;">
                        <div style="width: 50%;">
                            <div class="itemTitle">
                            GUESTS NAMES (child age):
                            </div>
                            <div class="itemText">
                                <div v-for="item, index in guestsNames" :key="index">
                                    {{item.text}}
                                </div>
                            </div>
                        </div>
                        <div style="width: 50%;">
                            <div class="itemTitle">
                                NUMBER OF NIGHTS:
                            </div>
                            <div class="itemText">
                                {{numberOfNight}}
                            </div>
                        </div>
                        </div>
                        <div style="display: flex;margin-top:30px;display: -webkit-box;">
                        <div style="width: 50%;">
                            <div class="itemTitle">
                                CHECK-IN DATE:
                            </div>
                            <div class="itemText">
                                {{checkinDate}}
                            </div>
                        </div>
                        <div style="width: 50%;">
                            <div class="itemTitle">
                                CHECK-OUT DATE:
                            </div>
                            <div class="itemText">
                                {{checkoutDate}}
                            </div>
                        </div>
                        </div>
                        <div style="display: flex;margin-top:30px;display: -webkit-box;">
                        <div style="width: 50%;">
                            <div class="itemTitle">
                                ROOM CATEGORY:
                            </div>
                            <div class="itemText">
                                {{roomCategory}}
                            </div>
                        </div>
                        <div style="width: 50%;">
                            <div class="itemTitle">
                                OFFER:
                            </div>
                            <div class="itemText">
                                {{offer}}
                            </div>
                        </div>
                        </div>
                    </div>
                    <div>
                        <div class="mainTilte">
                            INCLUSIONS:
                        </div>
                        <div class="mainText">
                            {{inclusions}}
                        </div>

                        <div v-if="transferTotalText.length > 0">
                            <div class="mainTilte">
                                ADD-ONS: Transfers included
                            </div>
                            <div class="mainText">
                                <!-- {{transfers}} -->
                                
                                <div v-for="item, index in transferTotalText" :key="index">
                                    <div style="color:black;font-size: 16px;font-weight: 600;margin-top:10px">{{item.title}}}</div>
                                    <div style="white-space: pre-wrap;">{{item.description}}</div>
                                </div>
                            </div>
                        </div>
                        
                        <div v-if="mealplanTotalText.length > 0">
                            <div class="mainTilte">
                                ADD-ONS: Meal plans included
                            </div>
                            <div class="mainText">
                                <div v-for="item, index in mealplanTotalText" :key="index">
                                    <div style="color:black;font-size: 16px;font-weight: 600;margin-top:10px">{{item.title}}}</div>
                                    <div style="white-space: pre-wrap;">{{item.description}}</div>
                                </div>
                            </div>
                        </div>
                        
                        <div v-if="festiveTotalText.length > 0">
                            <div class="mainTilte">
                                ADD-ONS: Festive supplement included
                            </div>
                            <div class="mainText">
                                <div v-for="item, index in festiveTotalText" :key="index">
                                    <div style="color:black;font-size: 16px;font-weight: 600;margin-top:10px">{{item.title}}}</div>
                                    <div style="white-space: pre-wrap;">{{item.description}}</div>
                                </div>
                            </div>
                        </div>
                        
                        <div v-if="honeymoonTotalText.length > 0">
                            <div class="mainTilte">
                                ADD-ONS: Honeymoon included
                            </div>
                            <div class="mainText">
                                <div v-for="item, index in honeymoonTotalText" :key="index">
                                    <div style="color:black;font-size: 16px;font-weight: 600;margin-top:10px">{{item.title}}}</div>
                                    <div style="white-space: pre-wrap;">{{item.description}}</div>
                                </div>
                            </div>
                        </div>


                        
                        <div class="mainTilte">
                            TERMS & CONDITIONS:
                        </div>
                        <div class="mainText">
                            {{termsConditions}}
                        </div>
                        
                        <div class="mainTilte">
                            SERVICE & AMENITIES:
                        </div>
                        <div class="mainText">
                            {{serviceAmenities}}
                        </div>
                        
                        <!-- <div class="mainTilte">
                            TRANSFER DETAILS:
                        </div> -->
                        <div class="mainText">
                            {{transferDetails}}
                        </div>
                        
                        <div class="mainTilte">
                IMPORTANT NOTE:
                        </div>
                        <div class="mainText">
                IN CASE OF ANY EMERGENCIES, PLEASE CONTACT THE FOLLOWING:
                HOTEL NUMBER: {{phoneNumber}}
                E-MAIL: {{email}}
                BEFORE YOU GO:
                {{importantNote}}
                        </div>


                        <div class="mainTilte">
                        TOTAL:
                        </div>
                        <div class="mainTextPrice">
                            <div style="margin-top: 10px;">
                                Total Price : USD ${{grossTotalPrice}}
                            </div>
                        </div>
                        <div class="mainTextPrice" style="margin: 10px;">
                            <div v-for="item, index in totalPrices" :key="index">
                                {{item.name}}: USD {{addZeroes(Math.round(item.price * 100) / 100)}} $
                            </div>
                        </div>

                    </div>
                    </div>
                <div style="display:flex;position: absolute;right: 20px;top: 40px;">
                
                    <a-tooltip placement="top">
                        <template slot="title">
                        <span>Download Pdf</span>
                        </template>
                        <a-icon style="margin-left:10px;color:black;font-size:20px;" type="download" @click="generateReport"/>
                    </a-tooltip>
                    <a-tooltip v-if="(bookingInfo.status == 1)" placement="top">
                        <template slot="title">
                        <span>Approve</span>
                        </template>
                        <a-icon style="margin-left:10px;color:green;font-size:20px;" type="check-circle" @click="AproveOne(bookingInfo.id)"/>
                    </a-tooltip>
                    <a-tooltip v-if="(bookingInfo.status != 3)" placement="top">
                        <template slot="title">
                        <span>Cancel</span>
                        </template>
                        <a-icon style="margin-left:10px;color:red;font-size:20px;" type="close-circle" @click="cancelOne(bookingInfo.id)"/>
                    </a-tooltip>
                    <a-tooltip placement="top">
                        <template slot="title">
                        <span>Remove</span>
                        </template>
                        <a-icon style="margin-left:10px;color:red;font-size:20px;" type="delete" @click="RemoveOne(bookingInfo.id)"/>
                    </a-tooltip>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import moment from 'moment';
import { api } from '../helpers/Helpers';
import VueHtml2pdf from 'vue-html2pdf'
export default {
    
    data() {
        return {
            bookingInfo:{
                agencyname: "",
                agentname: "",
                datalist: [],
                fromDate: "2022-07-28T00:00:00.000Z",
                guestnames: [],
                hotelid: "",
                hotelname: "",
                hotelimage1: "",
                hotelimage2: "",
                includeenhance: [],
                mainemail: "",
                mainphone: "",
                paystripeid: "",
                specialrequests: "",
                status: 0,
                taxat: 0,
                toDate: "2022-08-04T00:00:00.000Z",
                totaladultcount: 0,
                totalchildcount: 0,
                totalprice: 0
            },
            fromDate:'',
            toDate:'',
            days:0,

            hotelname:'',
            hotelimage1:'',
            hotelimage2:'',
            address:'',
            guestsNames: [],
            numberOfNight: 0,
            checkinDate: '',//'9 August, 2022',
            checkoutDate: '',//'14 August, 2022',
            roomCategory: '',
            offer: '',
            inclusions: '',

            transferTotalText:[],
            mealplanTotalText:[],
            festiveTotalText:[],
            honeymoonTotalText:[],

            transfers:`30-minute shared seaplane round-trip transfers to/from airport included`,
            grossTotalPrice:0,
            totalPrices:[],
            termsConditions: '',
            serviceAmenities:'',
            transferDetails:'',
            importantNote:'',
            confirmer:'',
            confirmationNo:'',
            phoneNumber: '',
            email: '',
            selectedHotel:{}

        }
    },
    
    components: {
        VueHtml2pdf
    },
    created () {
        this.initBooking();
    },
    
    methods: {
        moment,
        
        addZeroes(num){
            let textNum = num.toString();
                // // console.log("textNum  === ", Math.max(textNum.split('.')[1]?.length, 2));
            var _len = 0;
            if (textNum.split('.')[1] != undefined)
                _len = textNum.split('.')[1].length;
            let decimalResult = Number(textNum).toFixed(Math.max(_len, 2) || 2);
            let thousand = decimalResult.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return thousand;
        },
        initBooking:async function(){
            const _id = this.$route.query.id;
            if (_id != null){
                this.bookingInfo = await api.getBookingRequestInfo(_id);
                // console.log(this.bookingInfo);
                
                this.selectedHotel = await api.getHotel(this.bookingInfo.hotelid);
                // console.log(this.selectedHotel);

                this.fromDate = this.bookingInfo.fromDate;
                this.toDate = this.bookingInfo.toDate;
                
                const diffTime = Math.abs(Date.parse(this.toDate) - Date.parse(this.fromDate));
                this.days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));


                var totalPrices = [];

                var guestsNames = [];
                            
                var roomCategorys = [];
                var offers = [];
                
                if (this.bookingInfo.datalist != undefined && this.bookingInfo.datalist.length > 0){
                    for (let i = 0; i < this.bookingInfo.datalist.length; i++){
                        // var aInfo = {
                        //     text:this.bookingInfo.datalist[i].adultcount + ' adults and ' + this.bookingInfo.datalist[i].childcount + ' children' + this.getDisplayAgeStr(this.bookingInfo.datalist[i].childages) + '.'
                        // }
                        // guestsNames.push(aInfo);

                        var aPriceInfo = {
                            name: this.bookingInfo.datalist[i].roomname,
                            price: this.bookingInfo.datalist[i].price
                        }
                        totalPrices.push(aPriceInfo);

                        roomCategorys.push(this.bookingInfo.datalist[i].roomname);
                        offers.push(this.bookingInfo.datalist[i].promotionname);
                    }
                    for (let j = 0; j < this.bookingInfo.guestnames.length; j++){
                        var aInfo = {
                            text:this.bookingInfo.guestnames[j].firstname + ' ' + this.bookingInfo.guestnames[j].lastname
                        }
                        guestsNames.push(aInfo);
                    }
                    for (let j = 0; j < this.bookingInfo.guestchildnames.length; j++){
                        var aInfo = {
                            text:this.bookingInfo.guestchildnames[j].firstname + ' ' + this.bookingInfo.guestchildnames[j].lastname
                        }
                        guestsNames.push(aInfo);
                    }
                }

                this.hotelname = this.bookingInfo.hotelname;
                if (this.selectedHotel != undefined)
                    this.hotelname = this.selectedHotel.hotelname;

                this.hotelimage1 = this.bookingInfo.hotelimage1;
                this.hotelimage2 = this.bookingInfo.hotelimage2;

                this.address = this.bookingInfo.address;
                this.guestsNames = guestsNames;
                this.numberOfNight = this.days;
                this.checkinDate = moment(Date.parse(this.fromDate)).utc().format('D MMMM, YYYY');
                this.checkoutDate = moment(Date.parse(this.toDate)).utc().format('D MMMM, YYYY');
                this.roomCategory = roomCategorys.join(', ');
                this.offer = offers.join(', ');
                this.inclusions = this.bookingInfo.inclusiontext,
                
                this.transferTotalText = this.bookingInfo.transferTotalText;
                this.mealplanTotalText = this.bookingInfo.mealplanTotalText;
                this.festiveTotalText = this.bookingInfo.festiveTotalText;
                this.honeymoonTotalText = this.bookingInfo.honeymoonTotalText;

                this.transfers = `30-minute shared seaplane round-trip transfers to/from airport included`,
                this.totalPrices = totalPrices,
                this.grossTotalPrice = this.bookingInfo.grossTotalPrice,
                this.termsConditions = this.bookingInfo.termsconditions;
                this.serviceAmenities = this.bookingInfo.serviceAmenities;
                this.transferDetails = this.bookingInfo.transferDetails;
                this.importantNote = this.bookingInfo.importantNote;
                this.confirmer = this.bookingInfo.confirmer != undefined ? this.bookingInfo.confirmer : '';
                
                this.confirmationNo = this.bookingInfo.confirmationNo;// != undefined ? this.bookingInfo.confirmationNo : '';
                // if (this.selectedHotel.hoteldatageneral != undefined)
                //     this.confirmationNo = this.selectedHotel.hoteldatageneral.confirmationNo;
                this.phoneNumber = this.bookingInfo.hotelPhoneNumber,
                this.email = this.bookingInfo.hotelEmail
            }
        },
        getNameJoinString(_list){
            let resultStr = [];
            for (let i = 0; i < _list.length; i ++){
                resultStr.push(_list[i].firstname + " " + _list[i].lastname);
            }
            return resultStr.join(', ');
        },
        getDisplayAgeStr(_ageinfo){
            let displayAgeStrList = [];
            if(_ageinfo.length > 0){
                _ageinfo.forEach((element) => {
                    displayAgeStrList.push(element + ' years old');
                });
            }
            return displayAgeStrList.join(', ');
        },
        RemoveOne: function(_id){
            this.$confirm({
            title: 'Do you want to delete this booking?',
            // content: h => <div style="color:red;">Some descriptions</div>,
            onOk: ()=> {
                this.RemoveOneResult(_id);
            },
            onCancel() {
                
            },
            class: 'test',
            });
        },
        RemoveOneResult:async function(_id){
            const res = await api.removeBookingRequest(_id);
            // console.log(res, _id);
          this.$router.push({ path: 'bookings'})
        },
        
        AproveOne:async function(_id){
            const _info = {
                status: 2,
                confirmDate: new Date()
            }
            const res = await api.bookingRequestUpdate(_info, _id);
            // console.log(res, _id);
        },
        cancelOne:async function(_id){
            const res = await api.bookingRequestCancel(_id);
            // console.log(res, _id);
        },
        generateReport:async function() {
            // this.$refs.html2Pdf.generatePdf()
            
            // console.log("----this.bookingInfo._id- - - - - ", this.bookingInfo);
            let resPdf = await api.createBookingPdf(this.bookingInfo._id);
            // console.log("-----resPdf - -data- - - - - ", resPdf.data);
        }
    }

}
</script>
<style scoped>
.itemTitle{
    color: #1a1a1a;
    font-size: 16px;
    font-family: Montserrat;
    font-weight: 600;
    font-style: normal;
  }
  .itemText{
    color: #1a1a1a;
    font-size: 14px;
    font-family: Montserrat light;
    font-weight: 500;
    font-style: normal;
    margin-top:10px
  }
  .mainTilte{
    color: #1a1a1a;
    font-size: 16px;
    font-family: Montserrat;
    font-weight: 600;
    font-style: normal;
    width: 100%;
    background-color: #c8ad93;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .mainText{
    color: #494949;
    font-size: 14px;
    font-family: Montserrat light;
    font-weight: 500;
    font-style: normal;
    line-height: 30px;
    white-space: pre-wrap;
    padding-left: 0px;
    padding-right:0px;
  }
  .mainTextPrice{
    color: #494949;
    font-size: 14px;
    font-family: Montserrat light;
    font-weight: 500;
    font-style: normal;
    line-height: 24px;
    padding-left: 0px;
    padding-right:0px;
  }
</style>